import React from "react";
import { motion } from "framer-motion"
import { FaInstagram, FaTwitter, FaLinkedin, FaArrowDown, FaGithub } from "react-icons/fa";
import avatar from "../../assetsall/profile-image.webp";
const Hero = () => {
  const social = [
    {

      id: 1,
      link: "https://www.instagram.com/hellow_dipu/",
      icon: <FaInstagram />,
    },
    {
      id: 2,
      link: "https://twitter.com/Juniordipu",
      icon: <FaTwitter />,
    },
    {
      id: 3,
      link: "https://www.linkedin.com/in/dipongkor-roy/",
      icon: <FaLinkedin />,
    },
    {
      id: 4,
      link: "https://github.com/Dipongkor-Roy",
      icon: <FaGithub />,
    },
  ];

  // function for scroll down arrow hide

  window.addEventListener("scroll", function () {
    const downArrow = document.querySelector(".down-arrow");
    if (this.scrollY >= 90) downArrow.classList.add("hide-down-arrow");
    else downArrow.classList.remove("hide-down-arrow");
  });

  const fadeUp = {
    hidden: { opacity: 0, y: 20 },
    show: (i = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, delay: i * 0.12 },
    }),
  };

  return (

    <section className="min-h-screen flex flex-col justify-start items-center p-5 text-center">

      <motion.h1
        variants={fadeUp}
        initial="hidden"
        animate="show"
        custom={0}
        className="text-5xl text-rose-600 uppercase font-bold  "
      >
        Dipongkor Roy
      </motion.h1>
      <motion.h2
        variants={fadeUp}
        initial="hidden"
        animate="show"
        custom={1}
        className="py-3 text-2xl"
      >
        Freelance Full Stack Web Developer
      </motion.h2>
      <motion.p
        variants={fadeUp}
        initial="hidden"
        animate="show"
        custom={2}
        className="max-w-xl font-light text-gray-500"
      >
        Hello <span className="animate-pulse text-4xl">👋</span>
        I'm Dipongkor Roy, a freelance full stack developer from Bangladesh. I
        build fast, modern web apps and AI-powered applications with React,
        Next.js and Node.js &mdash; and I'm available for hire.
      </motion.p>

      {/* social icons  */}
      <motion.div
        variants={fadeUp}
        initial="hidden"
        animate="show"
        custom={3}
        className="flex justify-evenly py-8 lg:py-16 text-3xl w-full md:w-1/3"
      >
        {social.map(({ id, link, icon }) => (
          <motion.a
            href={link}
            key={id}
            target="_blank"
            rel="noopener noreferrer"
            className="cursor-pointer duration-300 hover:text-rose-600"
            whileHover={{ y: -4 }}
            whileTap={{ scale: 0.9 }}
          >
            {icon}
          </motion.a>
        ))}
      </motion.div>
      {/* avatar and resume */}
      <div>
        <motion.div initial={{ opacity: 0, scale: 0.5 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 1, duration: 0.5 }}  className="flex justify-center items-center  ">
          <img
            src={avatar}
            alt="avatar"
            className=" h-72  object-cover  bg-gradient-to-b from-rose-600 hover:from-teal-500 rounded-box aspect-square w-full  border-2 border-primary/10 bg-orange-200 p-0"
          />
        </motion.div>
        <motion.a
          href="https://www.linkedin.com/in/dipongkor-roy/"
          target="_blank"
          rel="noopener noreferrer"
          className="flex justify-center items-center mt-10 py-2 bg-gradient-to-r from-rose-600 to-teal-500 text-white hover:from-rose-700 hover:to-teal-700 rounded-lg z-20  relative"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
        >
         Resume
        </motion.a>
      </div>
      {/* arrow down animation */}
      <div className="mt-10 down-arrow">
        <FaArrowDown className="text-gray-400 text-2xl animate-bounce" />
      </div>

    </section>

  );
};

export default Hero;
